import { APIScopeData, Named } from '@ardoq/api-types';
import { comparePrimitiveValuesOrDates } from '@ardoq/common-helpers';
import { Locale } from '@ardoq/locale';

export const toScopeDataWithSortedComponentsAndWorkspacesByNames = (
  scopeData: APIScopeData,
  locale: Locale
): APIScopeData => {
  const sortNamedEntities = (compA: Named, compB: Named) =>
    comparePrimitiveValuesOrDates(compA.name, compB.name, locale);
  const sortedComponents = scopeData.components.toSorted(sortNamedEntities);
  const sortedWorkspaces = scopeData.workspaces.toSorted(sortNamedEntities);
  return {
    ...scopeData,
    components: sortedComponents,
    workspaces: sortedWorkspaces,
  };
};
